import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import isEmpty from 'lodash/isEmpty';
import React from 'react';

import useExportListImportPackageQuery from '@Modules/ImportPackage/Hooks/useExportListImportPackageQuery';

import { t } from '@System/i18n';

function ExportListImportPackage({ filters }) {
    const { refetch, isFetching } = useExportListImportPackageQuery(!isEmpty(filters) ? filters : undefined);
    return (
        <Button
            onClick={refetch}
            type="primary"
            loading={isFetching}
            icon={<DownloadOutlined />}
            className="_btn-export-list-import-package"
        >
            {t('btn.export_excel')}
        </Button>
    );
}
export default ExportListImportPackage;
